import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'I can find parkour drills and games for free. Why would I need this?',
  a: 'Free content gives you pieces — a move here, a game there. You still have to turn them into a class: add a warm-up, plan what the beginner does instead and keep the line moving. This gives you 59 complete sessions already assembled, in order, on a progression that covers the year.'
}, {
  q: 'What ages and groups does it cover?',
  a: 'Kids, teens and recreational groups, adults included. Every session has adapt notes for all three, and each skill volume opens with separate first sessions for kids and for teens/rec.'
}, {
  q: 'How many classes is that?',
  a: '59 Ready-Run Sessions across the six volumes — enough for a full school year at one class a week. Volume 6 adds 12-week term and 36-week year planners to sequence them, plus a blank master template to build your own.'
}, {
  q: 'What equipment do I need?',
  a: 'Mats, a few boxes or benches, and a rail or bar if you have one. Every session includes a no-gear or low-gear variant, and Bonus 02 shows you what to buy first and how to build safe DIY obstacles.'
}, {
  q: 'I coach big groups with mixed levels. Will it work?',
  a: 'That’s what Volume 6 is for. The Full-Gym Rotation runs stations so nobody waits in line, the Mixed-Level Grid runs one drill in three levels at once, and there’s a guide to scale any session from 6 to 30 students.'
}, {
  q: 'Is it safe for kids?',
  a: 'Every session is built landing-first: landing and roll mechanics come before anything else, every skill has a regression, and each unit includes safety cues and what to watch for. Volume 6 adds a pre-class risk sweep. You remain responsible for supervising your group and adapting to your space.'
}, {
  q: 'Is this a certification?',
  a: 'No. It’s a class-planning resource for coaches and instructors. It doesn’t replace your coaching qualification, first-aid training, insurance or your organisation’s safety policies.'
}, {
  q: 'Is it printable? How do I get it?',
  a: 'Landscape PDFs you can use on screen or print. Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-navy text-ink" data-id="element-84" data-mp="2denqd0uwipp0">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-85" data-mp="28g3zqn5d4pqb">
        <div className="text-center" data-id="element-86" data-mp="28eszgxb4m03y">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-87" data-mp="23grhygtcm8ul">Before you buy</p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-88" data-mp="1zew4yf22270z">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-89" data-mp="o096atutvqzu">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-navy-line bg-navy-card" data-id="element-90" data-mp="2zpp5cedego2l" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-91" data-mp="33pz71eu5ssbn">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-92" data-mp="3rfaa52yzeysy" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-93" data-mp="98xwr3a5z5q" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-94" data-mp="1x3dhj6oszmwb">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}